import React from "react";
import PropTypes from "prop-types";

const UpdatesTemplate = React.lazy(() =>
  import(/* webpackChunkName: "UpdatesTemplate" */ "../UpdatesTemplate")
);
const TestTemplate = React.lazy(() =>
  import(/* webpackChunkName: "TestTemplate" */ "../TestTemplate")
);

const PopupTemplates = ({ position, popupData, onClose }) => {
  if (popupData.templateName === "updates-template") {
    return (
      <React.Suspense fallback="">
        <UpdatesTemplate
          popupData={popupData}
          position={position}
          onClose={onClose}
        />
      </React.Suspense>
    );
  }

  return (
    popupData.templateName === "test-template" && (
      <React.Suspense fallback="">
        <TestTemplate
          popupData={popupData}
          position={position}
          onClose={onClose}
        />
      </React.Suspense>
    )
  );
};

PopupTemplates.propTypes = {
  popupData: PropTypes.object,
  position: PropTypes.string,
  onClose: PropTypes.func,
};

export default PopupTemplates;
